import { IconButton } from '@smart-tv/components/icon-button/icon-button';
import { PauseIcon } from '@smart-tv/components/icons/pause';
import { PlayIcon } from '@smart-tv/components/icons/play';
import {
  PLAYER_FOCUS_KEY_TOGGLE_PLAY
} from '@smart-tv/components/player/player-helpers';
import testIds from '@smart-tv/e2e/shared/variables';
import React, { memo } from 'react';
import { useSetAtom } from 'jotai';
import { playerBtnsFocusHistoryAtom } from './use-player-controls-navigation';
import useTogglePlayPause from '../../_hooks/use-toggle-play-pause';

const PausePlayButtons = () => {
  const { togglePlayPause, isPlaying, canToggle } = useTogglePlayPause();
  const setPlayerBtnsFocusHistory = useSetAtom(playerBtnsFocusHistoryAtom);

  if (!canToggle) return <></>;

  return isPlaying ? (
    <IconButton
      size="xl"
      focusKey={PLAYER_FOCUS_KEY_TOGGLE_PLAY}
      onClick={togglePlayPause}
      onNavFocus={() => setPlayerBtnsFocusHistory(PLAYER_FOCUS_KEY_TOGGLE_PLAY)}
      data-testid={testIds.player.playerControls.pause}
      icon={<PauseIcon />}
    >
      Pause
    </IconButton>
  ) : (
    <IconButton
      size="xl"
      focusKey={PLAYER_FOCUS_KEY_TOGGLE_PLAY}
      onClick={togglePlayPause}
      onNavFocus={() => setPlayerBtnsFocusHistory(PLAYER_FOCUS_KEY_TOGGLE_PLAY)}
      data-testid={testIds.player.playerControls.play}
      icon={<PlayIcon />}
    >
      Afspil
    </IconButton>
  );
};

export default memo(PausePlayButtons);
